package net.bothosting.docs.pages.hosting_in_bot_hosting_net

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initCreate_an_accountPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("hosting_in_bot_hosting_net/create_an_account.md", FrontMatterElement.Builder { addScalar("description", "Learn how to create your bot-hosting.net account and get ready to host your application."); addScalar("icon", "user-plus"); }))
}

@Page("/hosting_in_bot_hosting_net/create-an-account")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Create_an_accountPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("create-an-account") }) {
        org.jetbrains.compose.web.dom.Text("Create an Account")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To create a bot-hosting.net account, log in at ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/login") {
            org.jetbrains.compose.web.dom.Text("https://bot-hosting.net/login")
        }
        org.jetbrains.compose.web.dom.Text(" with Discord. Your account will be linked to your servers.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.WARNING, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Please make sure the email linked to your Discord account is verified. Otherwise, you will not be able to access the service.")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("what-s-next") }) {
        org.jetbrains.compose.web.dom.Text("What's next?")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("coin-system_explained.md") {
            org.jetbrains.compose.web.dom.Text("Coin System Explained")
        }
        org.jetbrains.compose.web.dom.Text(" - Learn how the coin system works and how to earn coins.")
    }
}
